import { VERSION } from './../../../environments/version';
import { HttpClient, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SKS_MASTER_API_ENDPOINT, IPIFY_ENDPOINT } from '../../../environments/environment';
import { delay } from 'rxjs/operators';

/** 外部との通信に関するメソッドをまとめるクラス */
export class UtilTransmission {

  /** 通信中のリクエスト数(interceptorで加算・減算される。ページ遷移後app.component.tsで0が代入される) */
  asyncRequesting = 0;
  requestingCount$: Observable<number> = new Observable(observer => {
    observer.next(this.asyncRequesting);
  });

  constructor(
    private http: HttpClient,
  ) {}

  /** 一意な画像ファイル名（SEQ）をAPIから取得 */
  getUniqImageSeq(apiPathName: string): Observable<Object> {
    // サーバーに送信
    return this.http.request('get',
    SKS_MASTER_API_ENDPOINT + `api/${apiPathName}/img_no/`);
  }

  /** ユーザーのグローバルIPを取得 */
  getCurrentUserGlobalIp(): Observable<object> {
    return this.http.jsonp(`${IPIFY_ENDPOINT}?format=jsonp&callback=JSONP_CALLBACK`, 'callback');
  }

  getCurrentTimeByDb(): Observable<any> {
    return this.http.get(`${SKS_MASTER_API_ENDPOINT}api/GetCurrentTime`);
  }

  /** DB更新基本カラムをreturn */
  returnBasicColumns(): object {
    const object = {
      tanto: 'smile9',
      ip: null,
      pg: null,
      angular_version: VERSION,
    };
    return object;
  }

  isURLContainHttps(urlString: string): boolean {
    const regExp = new RegExp('http(s)?://', 'gi');
    return regExp.test(urlString);
  }

  getOnlyS3FilePath(URL: string): string {
    const regexp = new RegExp(`https://s3.ap-northeast-1.amazonaws.com/uploads.rapid-c.com/`, 'i');
    URL = URL.replace(regexp, '');
    const index = URL.indexOf('.pdf');
    URL = URL.slice(0, index + 4);
    return URL;
  }

  /** 通信中リクエスト数を加算 */
  addAsyncRequesting() {
    /** Service側からプロパティ更新すると"ExpressionChangedAfterItHasBeenCheckedError"が発生する(親と子のComponentのプロパティの値が不一致の際に発生)
      * その防止の為、明示的に変更検知を実行する。(=delay(0)実行後にAngularは変更検知することを利用) */
     this.requestingCount$
      .pipe(delay(0))
      .subscribe(count => this.asyncRequesting++ );
  }

  /** 通信中リクエスト数を減算 */
  removeAsyncRequesting() {
    /** Service側からプロパティ更新すると"ExpressionChangedAfterItHasBeenCheckedError"が発生する(親と子のComponentのプロパティの値が不一致の際に発生)
      * その防止の為、明示的に変更検知を実行する。(=delay(0)実行後にAngularは変更検知することを利用) */
      this.requestingCount$
      .pipe(delay(0))
      .subscribe(count => this.asyncRequesting-- );
  }

  /** 通信中リクエスト数を0にする */
  resetAsyncRequesting() {
    /** Service側からプロパティ更新すると"ExpressionChangedAfterItHasBeenCheckedError"が発生する(親と子のComponentのプロパティの値が不一致の際に発生)
      * その防止の為、明示的に変更検知を実行する。(=delay(0)実行後にAngularは変更検知することを利用) */
     this.requestingCount$
      .pipe(delay(0))
      .subscribe(count => this.asyncRequesting = 0 );
  }

  /** 現在のパスを取得 */
  getCurretnPath(): string {
    let curretnPath = location.href;
    const protocol = location.protocol + '//';
    const host = location.host + '/';
    curretnPath = curretnPath.replace( new RegExp(protocol, 'g') , '' ) ;
    curretnPath = curretnPath.replace( new RegExp(host, 'g') , '' ) ;
    return curretnPath;
  }

}
